(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("potree-point-cloud", [], factory);
	else if(typeof exports === 'object')
		exports["potree-point-cloud"] = factory();
	else
		root["potree-point-cloud"] = factory();
})(self, function() {
return 